import { xhrPath } from '@/xhr/connections.js';
import picador from '@/xhr/connections/picador';

export default {
  async createSession() {
    return await picador.post('createSession', xhrPath.logger({}));
  },

  async addSessionLog(sessionId, data) {
    return await picador.post('addSessionLog', xhrPath.logger({ sessionId }), { payload: data });
  },
};
